import { Component, OnInit } from '@angular/core';
import { PostnewJob } from '../../services/job-section.service';
import { LoginService } from 'src/app/core/services/login.service';
import { Router } from '@angular/router';
import { id } from '@swimlane/ngx-charts';

@Component({
  selector: 'app-applied-jobs-listing',
  templateUrl: './applied-jobs-listing.component.html',
  styleUrls: ['./applied-jobs-listing.component.scss']
})
export class AppliedJobsListingComponent implements OnInit {

  constructor(private jobService: PostnewJob, private loginService: LoginService, private router: Router) { }
  loginDetails: any;
  applicants: any;
  openAccordionId: string | null = null;
  newMessage: string = '';
  EditedMessageId: string = '';
  displayMessage: any[] = [];
  ngOnInit(): void {

    this.loginDetails = this.loginService.getLoginData();

    this.loadMoreAppliedJobs();
  }


  appliedJobs: any[] = [];

  limit = 5;
  offset = 0;
  loading = false;
  endOfData = false;

  loadMoreAppliedJobs(): void {


    if (this.loading || this.endOfData) return;

    this.loading = true;


    this.jobService.getMyAppliedJobs(this.limit, this.offset).subscribe({
      next: (jobs) => {

        const enrichedJobs = jobs;
        if (enrichedJobs.length < this.limit) {
          this.endOfData = true;
        }

        this.appliedJobs = [...this.appliedJobs, ...enrichedJobs];

        this.offset += this.limit;
        this.loading = false;

      },
      error: (err) => {
        console.error("Error fetching jobs:", err);
        this.loading = false;
      }
    });

  }

  // viewJob(job: any): void {
  //   this.router.navigate(['/jobseek/jobdetails', job.id]);
  // }

  // Accordion
  toggleAccordion(job: any): void {



    this.openAccordionId = this.openAccordionId === job.id ? null : job.id; // Toggle the accordion
    this.newMessage = ''; // Clear the input box
    // Clear messages first
    this.displayMessage = [];

    this.getAllMessage(job?.id, job?.job_enquiries_find?.id);

  }

  getAllMessage(ApplicantId: any, EnquiryId: any) {

    this.jobService
      .getApplicantMessage(ApplicantId, EnquiryId)
      .subscribe((data) => {
        this.displayMessage = data;
      });
  }



  sendMessage(jobId: any): void {

    if (!this.newMessage.trim()) return; // Do not send empty messages

    // Find the job and add the message
    const messages = {
      message: this.newMessage,
      message_from: this.loginDetails.id,
      job_applicant_id: jobId.id
    };

    this.jobService.addApplicantMessage(messages);
    this.newMessage = ''; // Clear the input box
  }

  deleteMessage(messageId: string): void {

    this.jobService.deleteApplicantMessage(messageId).then(() => {

    }).catch((err) => {
      console.error("Error deleting message:", err);
    })
  }

  editMessage(message: any): void {
    this.newMessage = message.message;
    this.EditedMessageId = message.id;
  }

  UpdateMessage(editId: any): void {

    const UpdateMessage = {
      id: editId,
      message: this.newMessage,
    }

    this.jobService.editApplicantMessages(UpdateMessage.id, UpdateMessage.message).then(() => {
      this.EditedMessageId = '';
      this.newMessage = '';
    })

  }

  trackByJobId(index: number, job: any): string {

    return job.id;
  }




}
